module.exports = __webpack_public_path__ + "img/logo_u1992-23.17c656a4.svg";